var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 323,
    height: 65,
    viewBox: "0 0 323 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.8497 22.6884C71.746 11.989 112.91 15.6639 131.166 17.2887C149.422 18.9135 164.425 29.9903 161.529 40.6897C158.632 51.3891 131.361 39.5899 113.105 37.965C94.8496 36.3402 65.9533 33.3878 68.8497 22.6884Z",
    fill: "url(#paint0_linear_203_31)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.008 37.5258C166.882 47.8161 127.283 55.2365 109.725 58.5318C92.1671 61.827 70.0387 55.8515 64.1647 45.5611C58.2906 35.2708 91.926 38.7027 109.484 35.4074C127.042 32.1121 155.134 27.2355 161.008 37.5258Z",
    fill: "url(#paint1_linear_203_31)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.771 22.5239C127.771 33.3514 94.7375 57.4904 76.2631 57.4904C57.7887 57.4904 40 47.8642 40 37.0367C40 26.2092 54.9765 17.4317 73.4508 17.4317C91.9252 17.4317 127.771 11.6963 127.771 22.5239Z",
    fill: "url(#paint2_linear_203_31)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.65 14.5V48.5C31.65 48.85 31.85 49 32.15 49H33C33.3 49 33.5 48.85 33.5 48.5V14.5C33.5 14.2 33.3 14 33 14H32.15C31.85 14 31.65 14.2 31.65 14.5ZM61.2828 14H51.5328H39.9328C39.6328 14 39.4328 14.2 39.4328 14.5V15.2C39.4328 15.55 39.6328 15.7 39.9328 15.7H49.6828V48.5C49.6828 48.85 49.8828 49 50.1828 49H51.0328C51.3328 49 51.5328 48.85 51.5328 48.5V15.7H61.2828C61.5828 15.7 61.7828 15.55 61.7828 15.2V14.5C61.7828 14.2 61.5828 14 61.2828 14ZM75.2328 41.3L88.1828 20.9C88.4828 20.4 88.6328 19.95 88.6328 19.35V15.25C88.6328 14.45 88.1828 14 87.3828 14H66.3828C65.5828 14 65.1328 14.45 65.1328 15.25V20.45C65.1328 21.25 65.5828 21.7 66.3828 21.7H78.2828L65.3328 42.1C65.0328 42.6 64.8828 43.05 64.8828 43.65V47.75C64.8828 48.55 65.3328 49 66.1328 49H87.6328C88.4328 49 88.8828 48.55 88.8828 47.75V42.55C88.8828 41.75 88.4328 41.3 87.6328 41.3H75.2328ZM104.058 23.3C96.1582 23.3 90.6582 29.05 90.6582 36.5C90.6582 43.95 95.9582 49.7 104.258 49.7C109.358 49.7 113.458 47.45 115.408 43.1C115.808 42.3 115.308 41.7 114.408 41.7L109.608 41.75C108.958 41.75 108.558 42 108.058 42.4C107.158 43.15 105.758 43.65 104.358 43.65C101.708 43.65 99.4082 42.5 98.5082 39.5H109.108H115.208C115.958 39.5 116.458 39.15 116.558 38.35C116.608 37.75 116.658 37.15 116.658 36.5C116.658 28.95 111.358 23.3 104.058 23.3ZM98.4582 33.8C99.2082 31.35 101.158 29.95 104.008 29.95C106.208 29.95 108.408 31 109.158 33.8H98.4582ZM134.532 25.05L130.432 38.25L125.682 25C125.432 24.35 124.982 24 124.282 24H118.882C117.982 24 117.582 24.6 117.882 25.45L126.682 48.6L123.682 57.6C123.382 58.5 123.832 59 124.732 59H130.132C130.832 59 131.382 58.7 131.582 58L142.382 25.4C142.682 24.5 142.232 24 141.332 24H135.932C135.232 24 134.732 24.35 134.532 25.05ZM153.882 42L162.832 29.7C163.182 29.2 163.332 28.75 163.332 28.15V25.25C163.332 24.45 162.882 24 162.082 24H145.582C144.782 24 144.332 24.45 144.332 25.25V29.75C144.332 30.55 144.782 31 145.582 31H153.282L144.332 43.3C143.982 43.8 143.832 44.25 143.832 44.85V47.75C143.832 48.55 144.282 49 145.082 49H162.582C163.382 49 163.832 48.55 163.832 47.75V43.25C163.832 42.45 163.382 42 162.582 42H153.882Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173.05 53.128L169.35 51.878L183.45 10.928L187.15 12.178L173.05 53.128ZM197.91 43.878L195.66 40.328L208.61 32.428L195.66 24.478L197.86 20.978L213.86 31.028V33.878L197.91 43.878Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 42.0889L5.65 32.0889V29.2389L21.65 19.1889L23.85 22.6889L10.9 30.6389L23.85 38.5389L21.6 42.0889Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_31",
    x1: 76.5462,
    y1: 25.574,
    x2: 150.207,
    y2: 52.0295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EF83E",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_203_31",
    x1: 153.23,
    y1: 36.8669,
    x2: 79.9488,
    y2: 64.7422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E3EF8",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B156D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_203_31",
    x1: 115.486,
    y1: 19.2139,
    x2: 82.4137,
    y2: 68.7317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EECF8",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1A056",
    stopOpacity: 0.17
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7b260eb26b575864ad7c737945d6b4c8.svg";
export { ForwardRef as ReactComponent };